import { createSelector } from '@reduxjs/toolkit';

const getKarmaEarnEntity = ({ giftCards }) => giftCards;

export const waitingConfirmationSelector = createSelector(
  getKarmaEarnEntity,
  ({ waitingConfirmation }) => waitingConfirmation,
);

export const isCategoriesLoadedSelector = createSelector(
  getKarmaEarnEntity,
  ({ isCategoriesLoaded }) => isCategoriesLoaded,
);
export const categoriesSelector = createSelector(getKarmaEarnEntity, ({ categories }) => categories);
export const selectedCategoriesSelector = createSelector(
  getKarmaEarnEntity,
  ({ selectedCategories }) => selectedCategories,
);

export const isGiftCardsLoadingSelector = createSelector(
  getKarmaEarnEntity,
  ({ isGiftCardsLoading }) => isGiftCardsLoading,
);
export const isGiftCardsLoadedSelector = createSelector(
  getKarmaEarnEntity,
  ({ isGiftCardsLoaded }) => isGiftCardsLoaded,
);
export const isGiftCardsLeftSelector = createSelector(getKarmaEarnEntity, ({ isGiftCardsLeft }) => isGiftCardsLeft);
export const giftCardsSelector = createSelector(getKarmaEarnEntity, ({ giftCards }) => giftCards);

export const isPopularGiftCardsLoadingSelector = createSelector(
  getKarmaEarnEntity,
  ({ isPopularGiftCardsLoading }) => isPopularGiftCardsLoading,
);
export const isPopularGiftCardsLoadedSelector = createSelector(
  getKarmaEarnEntity,
  ({ isPopularGiftCardsLoaded }) => isPopularGiftCardsLoaded,
);
export const isPopularGiftCardsLeftSelector = createSelector(
  getKarmaEarnEntity,
  ({ isPopularGiftCardsLeft }) => isPopularGiftCardsLeft,
);
export const popularGiftCardsSelector = createSelector(getKarmaEarnEntity, ({ popularGiftCards }) => popularGiftCards);
